<div class="ratio ratio-16x9">
  <video controls #videoElement>
    <source [src]="materialUrl" [type]="material.mimetype" />
    @for (subtitle of material.subtitles; track subtitle) {
      <track
        [label]="subtitle.label"
        [kind]="subtitle.kind"
        [srclang]="subtitle.srclang"
        [src]="subtitle.src"
        [default]="subtitle.default" />
    }
    {{ "demo.educationalMaterial.preview.noVideoSupport" | translate }}
  </video>
</div>
